import type { AuthRepository, AuthResponse } from '@/domain/port/AuthRepository';
import type { User } from '@/domain/model/User';
import type { LoginRequest } from '@/application/dto/LoginRequest';
import type { SignupRequest } from '@/application/dto/SignupRequest';

export class AuthService {
  private readonly authRepository: AuthRepository;

  constructor(authRepository: AuthRepository) {
    this.authRepository = authRepository;
  }

  async login(request: LoginRequest): Promise<AuthResponse> {
    return this.authRepository.login(request.email, request.password);
  }

  async signup(request: SignupRequest): Promise<AuthResponse> {
    return this.authRepository.signup(request.name, request.email, request.password);
  }

  async getCurrentUser(): Promise<User> {
    return this.authRepository.getCurrentUser();
  }
}
